import React from 'react';

const Contact = () => {
    return (
        <div className="nt-home img-bg">
            <div className="ftp-overlay"></div>
            <div className="container">
                <div className="row rw-height mdl section-separator">            
                    <div className="col-lg-6">
                        <h2>Contact</h2>

                    </div>
                    <div className="col-lg-6">
                        <div className="row">
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;